<template>
  <div id="app">

    <ul class="header-links">
      <li class="header-spacer"><router-link class="header-link" to="/" exact>Johann</router-link></li
      ><li class="header-spacer"><router-link class="header-link" to="/code" exact>Code</router-link></li
      ><li class="header-spacer"><router-link class="header-link" to="/music" exact>Music</router-link></li
      ><li class="header-spacer"><router-link class="header-link" to="/stuff" exact>Stuff</router-link></li>
    </ul>

    <div>
      <div class="main-content">

        <transition :name="slideDirection" >
          <router-view></router-view>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      pageOrder: new Map([["", 0], ["code", 1], ["music", 2], ["stuff", 3]]),
      slideDirection: "slide slide-left",
      tweetRendered: false
    }
  },
  watch: {
    '$route' (to, from) {
      const pageNumFrom = this.pageOrder.get( from.path.split('/')[1] )
      const pageNumTo = this.pageOrder.get( to.path.split('/')[1] )

      this.slideDirection = pageNumFrom < pageNumTo ? 'slide-left' : 'slide-right'

    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.header-links{
  width: 400px;
  max-width: 100%;
  display: inline-block;
  padding: 0;
  margin-top: 20px;
  margin-bottom: 0px;
}
 @media screen and (min-width: 768px) {
   .header-links{
     margin-top: 50px;
     margin-bottom: 30px;
   }
 }

.header-spacer{
  text-align: center;
  width: 24%;
  list-style-type: none;
  display: inline-block;
}

a {
  text-decoration: none;
  color: #000;
  font-weight: 600;
  white-space: nowrap;
}

.header-link {
  font-size: 1.2rem;
  text-shadow: none;
  font-weight: normal;
  padding-right: 0.2rem;
}
.header-link.router-link-active {
  font-weight: 600;
}

.main-content {
  width: 600px;
  max-width: 100%;
  display: inline-block;
}

.slide-right-enter-active {
  transition: all .3s ease;
}
.slide-right-enter {
  transform: translateX(-50px);
  opacity: 0;
}
.slide-left-enter-active {
  transition: all .3s ease;
}
.slide-left-enter {
  transform: translateX(50px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?09417356